import { Component } from '@angular/core';
import { URLUtils } from '../urlUtils';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from '../https.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AddNotesModalComponent } from '../modal/add-notes-modal/add-notes-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LeadsService } from 'src/app/service/lead.service';

@Component({
    selector: 'app-queries-view',
    templateUrl: './queries-view.component.html',
    styleUrls: ['./queries-view.component.css'],
    standalone: false
})
export class QueriesViewComponent {

  leadId: string = '';
  lead: any;
  notes: any[] = [];
  activeTab = 'details';
  editMode: boolean = false;
  leadForm!: FormGroup;
  uid:any;

  specializations = [
    'Criminal Law', 
    'Civil Law', 
    'Corporate Law', 
    'Family Law', 
    'Immigration Law', 
    'IP Law',
    'Tax Law',
    'Real Estate Law',
    'Banking Law',
    'Other'
  ];

  countries: string[] = [
    "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", 
    "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", 
    "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", 
    "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", 
    "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", 
    "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", 
    "Congo", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", 
    "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", 
    "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji", 
    "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", 
    "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", 
    "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", 
    "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, North", 
    "Korea, South", "Kosovo", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", 
    "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", 
    "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", 
    "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", 
    "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", 
    "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Macedonia", 
    "Norway", "Oman", "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", 
    "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", 
    "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", 
    "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", 
    "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", 
    "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Sudan", 
    "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", 
    "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", 
    "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", 
    "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", 
    "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", 
    "Zimbabwe"
  ];

  colorClasses = [
    'timeline-blue', 'timeline-orange', 'timeline-green', 
    'timeline-purple', 'timeline-yellow', 'timeline-amber',
    'timeline-cyan', 'timeline-teal', 'timeline-pink'
  ];
  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private leadsService: LeadsService,
    private httpService: HttpService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.initializeForm();
    
    this.leadsService.currentLead.subscribe(lead => {
      if (lead) {
        this.lead = lead;
        //console.log('get serviceLead',this.lead)
        this.patchFormValues();
      }
    });
    
    this.getQueryNotes();
    this.route.params.subscribe(params => {
      this.leadId = params['id'];
      // this.getLeadDetails();
      // this.getLeadNotes();
    });
  }

  initializeForm() {
    this.leadForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', Validators.pattern('^[0-9]{10}$')],
      department: [''],
      status: [''],
      issue: [''],
      created: ['', Validators.required],
      additional_info: [''],
      notes: [''],
      address: this.fb.group({
        address_type: [''],
        house_flat_no: [''],
        street: [''],
        landmark: [''],
        city_town: [''],
        state: [''],
        country: [''],
        zipcode: ['']
      })
    });
  }

  getQueryNotes() {
    this.httpService.sendGetRequest(URLUtils.getQueryList()).subscribe((res: any) => {
      //this.lead = res;
      //console.log('res Notes',this.lead)

    });
  }

  getQueryDetails() {
    this.spinner.show();
    this.uid = localStorage.getItem('profuid');
    this.httpService.sendGetRequest(URLUtils.getLeadList(this.uid))
      .subscribe({
        next: (response: any) => {
          this.spinner.hide();
          this.lead = response.data;
          this.patchFormValues();
        },
        error: (error) => {
          this.spinner.hide();
          //this.toastr.error('Failed to load lead details');
        }
      });
  }


  patchFormValues() {
    //console.log('patch lead',this.lead)
    if (this.lead) {
      this.leadForm.patchValue({
        name: this.lead.name || '',
        email: this.lead.email || '',
        phone: this.lead.phone || '',
        department: this.lead.department || '',
        status: this.lead.status || '',
        issue: this.lead.issue && this.lead.issue.length > 0 ? this.lead.issue[0] : '',
        created: this.lead.created || '',
        additional_category: this.lead.additional_category || '',
        notes: this.lead.notes || '',
        address: {
          address_type: this.lead.address?.address_type || '',
          house_flat_no: this.lead.address?.house_flat_no || '',
          street: this.lead.address?.street || '',
          landmark: this.lead.address?.landmark || '',
          city_town: this.lead.address?.city_town || '',
          state: this.lead.address?.state || '',
          country: this.lead.address?.country || '',
          zipcode: this.lead.address?.zipcode || ''
        }
      });
    }
  }

  toggleEditMode() {
    this.editMode = !this.editMode;
    if (!this.editMode) {
      this.patchFormValues(); // Reset form if cancel editing
    }
  }

  saveChanges() {
    if (this.leadForm.invalid) {
      this.markFormGroupTouched(this.leadForm);
      return;
    }

    const formValues = this.leadForm.value;
    //console.log('formval',formValues)
    
    const address = {
      address_type: formValues.address?.address_type || '',
      house_flat_no: formValues.address?.house_flat_no || '',
      street: formValues.address?.street || '',
      landmark: formValues.address?.landmark || '',
      city_town: formValues.address?.city_town || '',
      state: formValues.address?.state || '',
      country: formValues.address?.country || '',
      zipcode: formValues.address?.zipcode || ''
    };
    //console.log('address',address)

    const payload: any = {
      name: formValues.name,
      email: formValues.email,
      phone: formValues.phone,
      department: formValues.department,
      address: address,
      account_status: formValues.status,
      issue: formValues.issue,
      notes_list: formValues.additionalDetails,
      country: formValues.country,
      additional_info: formValues.additional_info,
      id:this.lead.id  
    };
    //console.log('payload',payload)

    this.spinner.show();
    this.uid = localStorage.getItem('profuid');
    let id = this.lead.id;

    // Use Angular HttpClient to POST
    this.httpService.sendRePatchRequest(URLUtils.updateQuery(id, this.uid), payload).subscribe({
      next: (res) => {
        if(res){
          this.toggleEditMode();
          this.toastr.success('Enquiry updated successfully')
          //console.log('Success:', res);
          //this.activeModal.close(res);
        }else{
          //console.error('Error submitting lead:');
        }
    }
  })
  }

  setActiveTab(tab: 'details' | 'timeline') {
    this.activeTab = tab;
  }

  
  addNewNote() {
    const modalRef = this.modalService.open(AddNotesModalComponent, {
      centered: true,
      size: 'md',
      backdrop: 'static',    // disables closing on outside click
      keyboard: false,  
    });
    // modalRef.componentInstance.lead = { ...this.lead };
    // this.leadsService.setLead(this.lead); //pass doc data
    
    // Pass the query data and set the isQuery flag to true
    modalRef.componentInstance.lead = this.lead;
    modalRef.componentInstance.isQuery = true;
    modalRef.componentInstance.queryId = this.lead.id;
    
    modalRef.result.then((result) => {
      if (result) {
        this.getQueryNotes() 
       // this.toastr.success('Notes added successfully');

        const newNote = {
          add_on: new Date().toISOString(),    // Set today's date
          notes: result.notes,                 // Note title (small heading)
          content: result.note_content,         // Note content (description)
          color: '#4CAF50',                     // Optional: Green color or anything you want
          added_by: 'You'                       // Optional: Current logged-in user
        };
  
        if (!this.lead.notes_list) {
          this.lead.notes_list = [];
        }
        this.lead.notes_list = [...this.lead.notes_list, newNote]; 
        
      }
    }, (reason) => {
      // Modal dismissed
    });
  }

  markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if ((control as any).controls) {
        this.markFormGroupTouched(control as FormGroup);
      }
    });
  }

   viewDownloadDetails(lead: any)  {
    this.router.navigate(['/download-details', lead.id]);
    this.leadsService.setLead(lead);
  }

  get isEntity() {
    return this.lead.category === 'entity';
  }

  get isLawyer() {
    return this.lead.category === 'solo';
  }
}
